import React from 'react';

export const ConsentBadge = ({ record }) => {
  const yes = !!record?.marketing_consent;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs border ${yes ? 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' : 'bg-slate-500/15 text-slate-400 border-slate-500/30'}`}
      title={yes ? `Opted in ${record.marketing_consent_at?.slice(0, 10) || ''} · ${record.marketing_consent_source || ''} · v${record.marketing_consent_version || ''}` : 'No marketing consent on record'}
      data-testid="marketing-consent-badge"
    >
      Marketing Consent: {yes ? 'Yes' : 'No'}
    </span>
  );
};
